import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { InputNumber, message, Spin } from 'antd'
import { SGeneralForms, SFormUploadImage } from 'shj-components'
import { httpDictServTenant } from "@/services/fmsServices";
import dayjs from 'dayjs'
import { baseURL } from '@/api'
export const AddOrEditForm = (props: any) => {
  const uploadFileUrl = baseURL + `/file-web/file/upload`
  const { editData } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  const initFn = async () => {
    if (editData) {
      // setSpinning(true)
      editData.invoiceIssuanceDate = editData.invoiceIssuanceDate ? dayjs(editData.invoiceIssuanceDate) : undefined
      editData.createdTime = editData.createdTime ? dayjs(editData.createdTime) : undefined
      editData.noAmount = parseFloat((editData.amount - editData.taxAmount).toFixed(2)) || 0
      editData.filefUrl = [{
        uid: '1',
        name: editData.fileAbsoluteUrl || '请上传',
        status: 'done',
        filefUrl: editData.filefUrl,
        url: editData.fileAbsoluteUrl,
      }]
      formRef.current?.onFormRef()?.setFieldsValue({...editData})
      // setSpinning(false)
    }
  }
  const getOptions = async () => {
    const custInvoiceTypeList: any = await httpDictServTenant({
      parentKey: 'custInvoiceType',
      enabled: 1,
    })
    const transactionFeeTypeLists: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    return Promise.resolve({
      custInvoiceTypeList,
      transactionFeeTypeLists,
    })
  }
  const setAmount = () => {
    const amount = formRef.current?.onFormRef()?.getFieldValue('amount') || 0;
    const taxRateCode = formRef.current?.onFormRef()?.getFieldValue('taxRateCode') || 0;
    // 计算税额：发票金额(含税价)/(1+税率)*税率，保留2位小数
    const taxAmount = (amount / (1 + taxRateCode / 100) * taxRateCode / 100).toFixed(2);
    // 计算不含税金额：含税金额 - 税额，先将税额转回数字再计算
    const noAmount = parseFloat((amount - parseFloat(taxAmount)).toFixed(2));
    formRef.current?.onFormRef()?.setFieldsValue({
      taxAmount: taxAmount,
      noAmount: noAmount,
    });
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '开具时间',
                name: 'invoiceIssuanceDate',
                type: 'date',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '发票代码',
                name: 'invoiceCode',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '发票号码',
                name: 'invoiceNumber',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '发票类型',
                name: 'invoiceType',
                spanCol: 8,
                type: 'select',
                data: 'custInvoiceTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                },
              },
              {
                label: '交易类型',
                name: 'transactionType',
                spanCol: 8,
                type: 'select',
                data: 'transactionFeeTypeLists',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                },
              },
              {
                label: '发票金额（含税价）',
                name: 'amount',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children: (<InputNumber<number>
                  formatter={(value) => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value?.replace(/\￥\s?|(,*)/g, '') as unknown as number}
                  onChange={setAmount}
                />)
              },
              {
                label: '税率',
                name: 'taxRateCode',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children: (<InputNumber<number>
                  min={0}
                  formatter={(value) => `${value}%`}
                  parser={(value) => value?.replace('%', '') as unknown as number}
                  onChange={setAmount}
                />)
              },
              {
                label: '税额',
                name: 'taxAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '不含税金额',
                name: 'noAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '创建日期',
                name: 'createdTime',
                type: 'date',
                spanCol: 8,
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '发票附件',
                name: 'filefUrl',
                required: true,
                spanCol: 24,
                children: (<SFormUploadImage
                  maxCount={1}
                  accept=".pdf,.ofd,.jpg,.jpeg,.png,.gif"
                  url={uploadFileUrl}
                  limit={1}
                  action={baseURL + `/file-web/fileStore/upload`}
                />),
              },
              {
                label: '备注',
                type: 'textarea',
                name: 'description',
                spanCol: 24,
                comConfig: {
                  maxLength: 50,
                },
              },
            ],
          },
        ]}
      />
    </Spin>
  )
}
